import CreateInvestorWallet from "../../../../components/Investor/Tabs/Wallet/CreateInvestorWallet";

interface ICreateCustomerWallet {
  dataRecord: {
    funderId: number;
  };
  onCloseModal: () => void;
}

const CreateCustomerWallet = ({
  dataRecord,
  onCloseModal,
}: ICreateCustomerWallet) => {
  console.log("Data Record in CreateCustomerWallet:", dataRecord);
  return (
    <div
      className="Modal__dialog md-modal animated slideInDown"
      role="document"
      style={{ maxWidth: "95%", width: "1200px" }}
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
            <h3 className="Modal__title mb-0">Create Customer Wallet</h3>
          </div>
          <CreateInvestorWallet
            funderId={dataRecord?.funderId}
            goBack={onCloseModal}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateCustomerWallet;
